import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isInstagramErrorModalOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openInstagramErrorModal(state) {
      state.isInstagramErrorModalOpen = true;
    },
    closeInstagramErrorModal(state) {
      state.isInstagramErrorModalOpen = false;
    },
  },
});

export const { openInstagramErrorModal, closeInstagramErrorModal } = uiSlice.actions;

export default uiSlice.reducer;
